'use client';

import { sessionListHost } from '@/composition/hosts/session/session-list/session-list-host';
import { useSessionListVersion } from '@/composition/hosts/session/session-list/useSessionListVersion';
import {
  LazyConsolidatedSessionsBar as ConsolidatedSessionsBar,
  LazySessionsBar as SessionsBar,
  LazySessionsBarV2 as SessionsBarV2,
} from '@heidi/session';
import { memo } from 'react';

/**
 * Wrapper component that renders the appropriate sessions sidebar, following
 * the shared useSessionListVersion variant selection (same as
 * SessionsBarContent and the mobile SessionsPanelContent).
 *
 * Uses the door's lazy bars: a static bar would put its whole cone on every
 * route that reaches the `@heidi/session` door. Loading states are
 * handled internally by each component.
 */
export const SessionsContentLoader = memo(function SessionsContentLoader() {
  const sessionListVersion = useSessionListVersion();

  if (sessionListVersion === 'consolidated') {
    return <ConsolidatedSessionsBar host={sessionListHost} />;
  }
  if (sessionListVersion === 'v2') {
    return <SessionsBarV2 host={sessionListHost} />;
  }
  return <SessionsBar host={sessionListHost} />;
});
